import { Component } from '@angular/core';

@Component({
  selector: 'zodi-testing',
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.scss'],
})
export class TestingComponent {}
